var React = require('react');

function Flag (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"0.394562","width":"72","height":"72","rx":"36","fill":"white","key":0}),React.createElement("path",{"d":"M24.5264 47.4151V26.4151","stroke":"#2C0463","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M24.5264 41.2277V26.4151","stroke":"#E25215","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M24.5264 41.4147C32.5264 35.4147 38.5264 47.4147 46.5264 41.4147V26.4147C38.5264 32.4147 32.5264 20.4147 24.5264 26.4147","stroke":"#E25215","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

Flag.defaultProps = {"width":"72","height":"73","viewBox":"0 0 72 73","fill":"none"};

module.exports = Flag;

Flag.default = Flag;
